/*
 * @Author: your name
 * @Date: 2020-12-03 09:28:43
 * @LastEditTime: 2021-01-11 22:46:44
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vr-fornt-end\src\components\modeldemo\EnterPoint.js
 */
import * as THREE from 'three'
import { Vector2 } from 'three'
import { Camera } from './Camera'
import { CameraController } from './CameraController'
import { strToNumberArray, strToStrArray } from './Utils'

export const EnterType = {
  God: 1,
  GodToPano: 2,
  Pano: 3
}

export class Portal {
  constructor (pid, pAngle) {
    this.idx = pid
    this.angle = new THREE.Vector2().fromArray(pAngle)
  }
}

export class EnterPointSet {
  constructor (enterType, portals) {
    this.enterType = enterType
    this.portals = {}
    for (const p of portals) {
      this.portals[p.portalPointIndex] = new Portal(p.pointId, [p.portalLonAngle, p.portalLatAngle])
    }
  }
}
